export default class Filters {
	constructor($module) {
		this.$module = $module;

		const filterBody = document.getElementById("filters");
		const filterHeader = document.getElementById("filters-title");

		
		filterHeader.addEventListener("click", toggleFilters);

		function toggleFilters() {
			if ($(window).width() <= 992) {
			filterBody.classList.toggle("active");
			}
		}

		const viewportWidth =
			window.innerWidth || document.documentElement.clientWidth;
		if (viewportWidth > 992) {
			filterBody.classList.add("active");
		} if (viewportWidth < 992) {
			filterBody.classList.remove("active");
		}

		// Fixed Resize Screen Function
		// window.addEventListener("resize", () => {
		// 	if (this.innerWidth > 992) {
		// 		if (filterBody.classList.contains("active")) {
		// 			toggleFilters();
		// 		}
		// 	}
	
		// });
		$(window).resize(function() {
			const viewportWidth =
			window.innerWidth || document.documentElement.clientWidth;
			if (viewportWidth > 992) {
				filterBody.classList.add("active");
			} if (viewportWidth < 992) {
				filterBody.classList.remove("active");
			}
		  })
		}
}
